// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".KeybeAvatar-img[data-v-f09cd0b4]{-o-object-fit:cover;object-fit:cover;border-radius:50%;background-color:#fff}.smallText[data-v-f09cd0b4]{font-size:10px}", ""]);
// Exports
module.exports = exports;
